import {
    useCheckAuth,
    useSpringBigStore
} from '@springbig/shared';
import { useEffect, useState } from 'react';
import { useAppNavigate } from '~/pages';

export const useAuthorization = () => {

    const { error: authError } = useCheckAuth();
    const [isLoadingAuth, setIsLoadingAuth] = useState(false);

    const { cleanState } = useSpringBigStore();
    const { params } = useAppNavigate();
    const { navigate } = useAppNavigate();

    useEffect(
        () => {

            if (authError) {
                navigate(`w/${params.wallet_id}`);
                setIsLoadingAuth(false);
            }
        },
        [authError, cleanState, navigate, params.wallet_id]
    );

    return {
        isLoadingAuth,
        authError
    };
};
